import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import { Col, Dropdown, Flex, Form, Modal, Row, message } from "antd";
import { AppstoreOutlined, SearchOutlined } from "@ant-design/icons";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Skeleton } from "antd";

import type { MenuProps } from "antd";

import type { FilterValue, SorterResult } from "antd/es/table/interface";

import Highlighter from "react-highlight-words";
import type { InputRef } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { ColumnType, ColumnsType } from "antd/es/table";
import type { FilterConfirmProps } from "antd/es/table/interface";
import {} from "@mui/x-data-grid";

import axios from "axios";

import Globais, {
  enviarEmail,
  formatarData,
  logout,
  validateToken,
} from "../../components/Globais";

import MenuItem from "@mui/material/MenuItem";
import ModalInfoPagamento from "./Components/ModalInfoPagamento";
import ModalEditarEmail from "./Components/ModalEditarEmail";
import DrawerAndamentosUsuario from "./Components/DrawerAndamentosUsuario";
import { useNavigate } from "react-router-dom";

const Container = styled.section`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template: 10% 90% / 100%;
`;
const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: flex;

  justify-content: center;
  align-items: center;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  grid-template: 10% 90% / auto;
`;

const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

interface DataType {
  id: number;
  key: string;
  nome: string;
  sobrenome: string;
  email: string;
  cpf: string;
  celular: string;
  active: string;
  nda: string;
  created_at: string;
}

interface Values {
  title: string;
  description: string;
  modifier: string;
}
interface CollectionCreateFormProps {
  open: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}

type DataIndex = keyof DataType;

type MenuItem = Required<MenuProps>["items"][number];

export default function ViewGerenciarPropriedades() {
  const [usuarioData, setUsuarioData] = useState<any>();
  const [semFiltros, setSemFiltros] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [openMensagem, setOpenMensagem] = useState(false);
  const [openEditarEmail, setOpenEditarEmail] = useState(false);
  const [emailSelecionado, setEmailSelecionado] = useState("");
  const [openAndamentos, setOpenAndamentos] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const active = useRef("");
  const nome = useRef("");
  const userId = useRef(0);
  const [messageApi, contextHolder] = message.useMessage();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const [isLoading, setIsLoading] = useState(true);

  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({});

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };

  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };

  const { TextArea } = Input;

  const CollectionCreateForm: React.FC<CollectionCreateFormProps> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={open}
        title="Mandar E-mail"
        okText="Enviar"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values: any) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="title"
            label="Assunto"
            rules={[
              { required: true, message: "Por favor insira um assunto!" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Mensagem"
            rules={[
              { required: true, message: "Por favor insira uma mensagem!" },
            ]}
          >
            <TextArea size="large" autoSize={{ minRows: 2, maxRows: 6 }} />
          </Form.Item>
          <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item>
        </Form>
      </Modal>
    );
  };

  const navigate = useNavigate();

  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const Token = validateToken();
    const perfil = Token?.nda;

    const situacao = active.current;
    const id = userId.current;
    let nomeProp = nome.current;

    switch (key) {
      case "14":
        setOpenAndamentos(true);
        break;
      case "13":
        if (situacao === "Ativo") {
          error("Só pode ser alterado um usuário que esteja Inativo.");
        } else if (situacao === "Inativo") {
          setEmailSelecionado((usuarioData || []).find((usuario: DataType) => usuario.id === id)?.email || "");
          setOpenEditarEmail(true);
        }
        break;
      case "1":
        document.location.href = `/gerenciarPropriedades/?userId=${id}&&nomeProp=${nomeProp}`;
        break;
      case "2":
        navigate("/gerenciarInteressesProprietarios", {
          state: { userId: id, nomeProp: nomeProp },
        });
        break;
      case "3":
        if (situacao === "Bloqueado-Inativo") {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { active: 0 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário desbloqueado com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        } else {
          error("Não é permitido inativar um usuário");
        }

        break;

      case "4":
        if (situacao === "Inativo") {
          error(
            "Você não pode ativá-lo. O usuário deverá clicar em esqueci a senha e seguir os trâmites para alterá-la. Dessa forma ele estará ativo novamente."
          );
        } else {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { active: 1 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário ativado com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        }

        break;

      case "5":
        if (situacao === "Inativo") {
          error("O usuário deverá estar ativo antes de identificá-lo.");
        } else {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { active: 2 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário identificado com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        }
        break;
      case "6":
        if (situacao === "Inativo") {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { active: 4 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário bloqueado com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        } else {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { active: 3 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário bloqueado com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        }
        break;
      case "7":
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
          let formData = { nda: 0 };
          ////
          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              success("Usuário selecionado agora é um proprietário!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
        break;
      case "8":
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
          let formData = { nda: 3 };
          ////
          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              success("Usuário selecionado agora é um representante!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
        break;
      case "9":
        if (perfil === 1) {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { nda: 2 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário selecionado agora é um operador!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        } else {
          error("Somente administradores podem atribuir o perfil de operador");
        }

        break;
      case "10":
        if (perfil === 1) {
          if (Token) {
            const URL = `${Globais.DOMINIOBACK}/usuario/${id}`;
            let formData = { nda: 1 };
            ////
            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                success("Usuário selecionado agora é um administrador!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          } else {
            document.location.href = "/";
          }
        } else {
          error(
            "Somente administradores podem atribuir o perfil de administrador!"
          );
        }

        break;
      case "11":
        if (userId.current) {
          setOpenMensagem(true);
        }
        break;

      case "12":
        if (perfil === 1) {
          showModal();
        } else {
          alert("Opção Disponível apenas para o administrador");
        }
    }
  };
  const items: MenuProps["items"] = [
    { key: "1", label: "Propriedades" },
    { key: "2", label: "Interesses" },
    getItem("Mudar Situação", "sub2", <AppstoreOutlined />, [
      getItem("Inativo", "3"),
      getItem("Ativo", "4"),
      getItem("Identificado", "5"),
      getItem("Bloqueado", "6"),
    ]),
    getItem("Mudar Perfil", "sub3", <AppstoreOutlined />, [
      getItem("Proprietário", "7"),
      getItem("Representante", "8"),
      getItem("Operador", "9"),
      getItem("Administrador", "10"),
    ]),
    { key: "11", label: "Mandar mensagem" },
    { key: "13", label: "Editar" },
    { key: "14", label: "Andamentos" },

    { key: "12", label: "Informações de Pagamento" },
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      const props = {};

      let obj = localStorage.getItem("filtrosGerUsuarios");
      let page = localStorage.getItem("pageGerUsuarios");
      if (obj) {
        let novoFiltro = JSON.parse(obj);

        setFilteredInfo({
          nome: novoFiltro.nome,
          email: novoFiltro.email,
          cpf: novoFiltro.cpf,
          celular: novoFiltro.celular,
          active: novoFiltro.active,
          nda: novoFiltro.nda,
          created_at: novoFiltro.created_at,
        });
        setSemFiltros(false);
      }
      if (page) {
        setCurrentPage(+page);
        setSemFiltros(false);
      }

      if (Token) {
        if (Token.nda === 0) {
          document.location.href = "/sempermissao";
        } else {
          const URL = `${Globais.DOMINIOBACK}/usuario/informacoes`;

          try {
            const response = await axios.post(URL, props, {
              headers: { Authorization: Token.AuthStr },
            });

            if (response) {
              let ArrayNovo = response.data.filter(async (p: any) => {
                p.key = p.id;
                p.nome = `${p.nome} ${p.sobrenome}`;
                if (p.active === 0) {
                  p.active = "Inativo";
                } else {
                  if (p.active === 1) {
                    p.active = "Ativo";
                  } else {
                    if (p.active === 2) {
                      p.active = "Identificado";
                    } else {
                      if (p.active === 3) {
                        p.active = "Bloqueado";
                      } else {
                        if (p.active === 4) {
                          p.active = "Bloqueado-Inativo";
                        }
                      }
                    }
                  }
                }
                if (p.nda === 0) {
                  if (p.status === "PENDENTE") {
                    p.nda = "Prop. Pendente";
                  } else {
                    if (p.status === "REGULAR") {
                      p.nda = "Prop. Regular";
                    }
                  }
                } else {
                  if (p.nda === 1) {
                    p.nda = "Administrador";
                  } else {
                    if (p.nda === 2) {
                      p.nda = "Operador";
                    } else {
                      if (p.nda === 3) {
                        p.nda = "Interessado";
                      } else {
                        if (p.nda === 4) {
                          p.nda = "Hóspede";
                        }
                      }
                    }
                  }
                }
                p.created_at = formatarData(p.created_at);
                return p;
              });

              setUsuarioData(ArrayNovo);
              setIsLoading(false);
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
            }
          }
        }
      }
    };
    fetchToken();
  }, []);

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      width: "40%",
      filteredValue: filteredInfo.nome,
      ...getColumnSearchProps("nome"),
      sorter: (a, b) => a.nome.length - b.nome.length,
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      filteredValue: filteredInfo.email,
      ...getColumnSearchProps("email"),
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      key: "cpf",
      width: "20%",
      filteredValue: filteredInfo.cpf,
      ...getColumnSearchProps("cpf"),
    },
    {
      title: "Celular",
      dataIndex: "celular",
      key: "celular",
      width: "20%",
      filteredValue: filteredInfo.celular,
      ...getColumnSearchProps("celular"),
    },
    {
      title: "Situação",
      dataIndex: "active",
      key: "active",
      width: "10%",
      filteredValue: filteredInfo.active,

      filters: [
        { text: "Ativo", value: "Ativo" },
        { text: "Inativo", value: "Inativo" },
        { text: "Identificado", value: "Identificado" },
        { text: "Bloqueado", value: "Bloqueado" },
        { text: "Bloqueado-Inativo", value: "Bloqueado-Inativo" },
      ],
      onFilter: (value: any, record) => record.active.includes(value),
      filterSearch: true,
    },
    {
      title: "Perfil",
      dataIndex: "nda",
      key: "nda",
      width: "30%",
      filteredValue: filteredInfo.nda,

      filters: [
        { text: "Administrador", value: "Administrador" },
        { text: "Operador", value: "Operador" },
        { text: "Prop. Regular", value: "Prop. Regular" },
        { text: "Prop. Pendente", value: "Prop. Pendente" },
        { text: "Interessado", value: "Interessado" },
        { text: "Hóspede", value: "Hóspede" },
      ],
      onFilter: (value: any, record) => record.nda.includes(value),
      filterSearch: true,
    },
    {
      title: "Data de cadastro",
      dataIndex: "created_at",
      key: "created_at",
      width: "20%",
      filteredValue: filteredInfo.created_at,
      ...getColumnSearchProps("created_at"),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                userId.current = row.id;
                active.current = row.active;
                nome.current = row.nome;
                setEmailSelecionado(row.email);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    setFilteredInfo({
      nome: filters.nome,
      email: filters.email,
      cpf: filters.cpf,
      celular: filters.celular,
      active: filters.active,
      nda: filters.nda,
      created_at: filters.created_at,
    });

    if (pagination.current) {
      let page = pagination.current.toString();
      localStorage.setItem("pageGerUsuarios", page);
    }

    localStorage.setItem("filtrosGerUsuarios", JSON.stringify(filters));
    setSemFiltros(false);
  };

  const handleFilter = () => {
    localStorage.removeItem("filtrosGerUsuarios");
    localStorage.removeItem("pageGerUsuarios");
    setSemFiltros(true);
    document.location.reload();
  };

  // State de abertura e fechamento do modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Funçao para abrir o modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <ContainerFiltro>
            {contextHolder}
            <Col span={3}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                  <ArrowBackIcon color="primary" />
                </a>
              </Flex>
            </Col>
            <Col span={18}>
              <Flex align="center" justify="center">
                <PeopleAltIcon color="primary" fontSize="large" />
                <h1>Usuários</h1>
              </Flex>
            </Col>
            <Col span={3}>
              <Row>
                <Col style={{ marginRight: 20 }}>
                  {semFiltros ? (
                    <Button
                      onClick={handleFilter}
                      type="primary"
                      disabled={true}
                      style={{ marginBottom: 16, alignSelf: "left" }}
                    >
                      <FilterAltIcon />
                    </Button>
                  ) : (
                    <Button
                      onClick={handleFilter}
                      type="primary"
                      style={{ marginBottom: 16, alignSelf: "left" }}
                    >
                      <FilterAltOffIcon />
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
          </ContainerFiltro>
          <ContainerLista>
            <CollectionCreateForm
              open={openMensagem}
              onCreate={async function (values: Values): Promise<void> {
                let resposta = await enviarEmail({
                  userId: userId.current,
                  tipoEmail: 1,
                  subjectEmail: values.title,
                  bodyEmail: values.description,
                });

                console.log("resposta");
                console.log(resposta);

                switch (resposta) {
                  case "VERIFICARZAP":
                    warning(
                      "Parece haver algum problema com a API do ZAP. Verificar o Wasseler."
                    );

                    break;
                  case "FALHAZAP":
                    warning(
                      "Não foi possível enviar mensagem no whatsapp. Verificar número de telefone. Não enviamos o e-mail também"
                    );

                    break;
                  case "FALHAEMAIL":
                    warning(
                      "Mensagem enviada no zap mas não foi possível enviar e e-mail."
                    );
                    break;
                  case "OK":
                    success("Mensagens enviadas com sucesso.");
                    setOpenMensagem(false);

                    setTimeout(() => {
                      setOpenMensagem(false);
                    }, 2000);
                    break;
                  default:
                    error(
                      "Há algo de errado. Mensagem não enviada. Código de erro: GLB-001"
                    );
                }
              }}
              onCancel={function (): void {
                setOpenMensagem(false);
              }}
            />
            <Table
              columns={columns}
              dataSource={usuarioData}
              onChange={onChange}
              bordered
              pagination={{ defaultCurrent: currentPage }}
            />
          </ContainerLista>
          <ModalInfoPagamento
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            usuarioId={userId.current}
          />
          <ModalEditarEmail
            open={openEditarEmail}
            usuarioId={userId.current}
            email={emailSelecionado}
            onCancel={() => setOpenEditarEmail(false)}
          />
          <DrawerAndamentosUsuario
            open={openAndamentos}
            usuarioId={userId.current}
            onClose={() => setOpenAndamentos(false)}
          />
        </Container>
      )}
    </>
  );
}
